export default __webpack_public_path__ + "static/media/Engineer_Peter.f8710b5a.jpg";